import {
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
  Button,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
  },
  offset: theme.mixins.toolbar,
  logo: {
    width: "36px",
    marginRight: "10px",
  },
}));

export const Appbar = () => {
  const classes = useStyles();

  const handleClick = () => {
    // window.location.assign("/contacto");
    window.location.href = "/contacto";
  };

  return (
    <>
      <AppBar position="fixed" color="primary" elevation={0}>
        <Toolbar className={classes.wrapper}>
          <Typography variant="h2" className={classes.title}>
            <img
              src="./logo.png"
              alt="logo seguros contar"
              className={classes.logo}
            />
            Seguros Contar
          </Typography>
          <Button variant="outlined" color="inherit" onClick={handleClick}>
            Contacto
          </Button>
        </Toolbar>
      </AppBar>
      <div className={classes.offset} />
    </>
  );
};
